import React from 'react';
import { ConditionCategory, CATEGORY_COLORS } from '../types/condition';
type CategoryBadgeProps = {
  category: ConditionCategory;
  size?: 'sm' | 'md';
};
export function CategoryBadge({
  category,
  size = 'sm'
}: CategoryBadgeProps) {
  const colors = CATEGORY_COLORS[category];
  return <span className={`
        inline-flex items-center font-medium rounded-full border
        ${colors.bg} ${colors.text} ${colors.border}
        ${size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm'}
      `} data-id="element-68">
      {category}
    </span>;
}